export default "__VITE_ASSET__oxIqUplw__"